<template>
  <section id="main-content">
    <h1 v-if="currentModality=='student'">Em qual escola vocês estudam?</h1>
    <h1 v-else>Em qual escola você trabalha?</h1>

    <div id="school-selection" v-if="!schoolSelected">
      <div>
        <label class="generic-label" for="inep-search">Matrícula no MEC (Código&nbsp;INEP)</label>
        <div id="inep-search-container">
          <input
            placeholder="Código da sua escola. Por exemplo: 35045949"
            type="number"
            id="inep-search"
            class="generic-input number-with-no-spinner"
            v-model="idToSearch"
            v-on:keyup.enter="searchForSchool"
          />
          <button class="btn-action" @click="searchForSchool" :class="{'btn-loading': amILoading}" :disabled="amILoading || !searchDirty || idToSearch==''">Procurar</button>
        </div>
        <ul class="tips small-tips">
          <li>
            Para descobrir a matrícula de sua escola, por favor consulte o
            <a
              href="https://www.gov.br/inep/pt-br/acesso-a-informacao/dados-abertos/inep-data/catalogo-de-escolas"
              target="_blank"
            >site do INEP</a>  ou a secretaria de sua escola.
          </li>
          <li>
            Se a sua escola for nova é possível que ela não se encontre ainda no cadastro do MEC. Nesse caso, por favor
            <a
              href="https://unicamp.zohodesk.com/portal/pt/newticket"
            >entre em contato</a> conosco.
          </li>
        </ul>

        <!-- <small v-if="searchDirty">PESQUISA DESATUALIZADA</small> -->
      </div>
      <div v-if="searchStatus == 'finished'">
        <div v-for="school in foundSchools" v-bind:key="school.id" class="found-schools">
          <div class="inep-data">
            <h2>{{school.NewSuiInstitution.name}}</h2>
            <p>
              Escola {{schoolType(school.NewSuiInstitution.type)}} de
              <span>{{fixesAllCaps(school.NewSuiInstitution.city)}},</span>
              {{school.NewSuiInstitution.state}}.<br/>
              <small>Código INEP: {{school.NewSuiInstitution.id}}</small>
            </p>
          </div>
          <button
            class="btn-main-action"
            @click="dispatchSelectedSchool(school.NewSuiInstitution.id)"
          >Escolher esta escola</button>
        </div>
        <div v-if="!foundSchool" class="found-schools">
          <div>
            Não encontramos nenhuma escola registrada sob o código
            <span class="mono">{{searchedId}}</span>. Se você estiver certo de que o código está correto, por favor
            <a
              href="https://unicamp.zohodesk.com/portal/pt/newticket"
            >entre em contato</a>.
          </div>
        </div>
      </div>
      <!-- <div v-if="searchStatus == 'searching'">PROCURANDO A ESCOLA</div> -->
    </div>
    <div id="selected-school" v-if="schoolSelected">
      <h2>{{chosenSchoolData.NewSuiInstitution.name}}</h2>
      <p>Escola {{schoolType(chosenSchoolData.NewSuiInstitution.type)}} de {{chosenSchoolData.NewSuiInstitution.city}}, {{chosenSchoolData.NewSuiInstitution.state}}.</p>
      <button class="btn-action" @click="unselectSchool">Escolher outra escola</button>
    </div>
  </section>
</template>

<script>
import store from "../../store";
import router from "../../router";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  name: "StepInstitution",
  computed: {
    ...mapGetters(["currentModality", "chosenSchoolData","amILoading"]),
    idToSearch: {
      get: function() {
        return store.state.InstitutionSearch.idToSearch;
      },
      set: function(value) {
        store.commit("CHANGE_INSTITUTION_SEARCH_ID", value);
      }
    },
    searchedId: function() {
      let id = store.state.InstitutionSearch.RetrievedSearch.Criteria.id;
      if (id == "") {
        return "[vazio]";
      }
      return id;
    },
    foundSchool: function() {
      return store.state.InstitutionSearch.RetrievedSearch.Results.length > 0;
    },
    searchDirty: function() {
      return !(
        store.state.InstitutionSearch.RetrievedSearch.state == "finished" &&
        store.state.InstitutionSearch.idToSearch ==
          store.state.InstitutionSearch.RetrievedSearch.Criteria.id
      );
    },
    searchStatus: function() {
      return store.state.InstitutionSearch.RetrievedSearch.state;
    },
    foundSchools: function() {
      return store.state.InstitutionSearch.RetrievedSearch.Results;
    },
    schoolSelected: function() {
      return store.state.Subscription.NewSuiApplication.sui_institution_id != null;
    }
  },
  methods: {
    ...mapActions(["searchForSchool", "unselectSchool"]),
    dispatchSelectedSchool: function(school) {
      store.dispatch("selectSchool", school).then(() => {
        let step;
        if (store.getters.currentModality == "student") {
          step = "terms_and_conditions";
        } else {
          step = "teachers";
        }
        router.push({
          name: "nothingButFlowers",
          params: {
            subsSlug: store.state.Subscription.subscription_slug,
            step: step
          }
        });
      });
    },
    schoolType: function(type) {
      let types = { public: "pública", private: "privada", public_with_selection: "pública COM PROCESSO SELETIVO"};
      if (type in types) {
        return types[type];
      }
      return type;
    },
    fixesAllCaps: function(s) {
      //https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
      return s.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

#school-selection {
  margin: pad(0) 0 0;
  @extend .white-box;
}

#inep-search-container {
  display: grid;
  grid-template-columns: auto min-content;

  @include respond-below(sm) {
    grid-template-columns: 1fr;
  }

  grid-gap: pad(-1);
  padding: pad(-1) 0;
  margin-bottom: pad(0);

  .generic-input {
    @include respond-below(md) {
      @include fs(0);
    }
  }
}

.found-schools {
  background: secondary-color(0);
  padding: pad(0) pad(1);
  margin: pad(0) 0 0;

  position: relative;
  width: calc(100% + #{2 * pad(1)});
  left: -1 * pad(1);

  @include respond-below(sm) {
    width: calc(100% + #{2 * pad(0)});
    left: -1 * pad(0);
    padding: pad(-1) pad(0) pad(0);
  }

  display: grid;
  grid-template-columns: auto max-content;
  grid-gap: pad(0);

  @include respond-below(md) {
    grid-template-columns: 1fr;
  }

  h2 {
    font-weight: 200;
    letter-spacing: -0.01em;
    margin-bottom: pad(-2);
  }
}
</style>
